module.exports = __webpack_public_path__ + "static/media/PWID-X-02.4c5520af.png";